/**
 * Replace template variables in question text with actual values.
 * Variables: [program], [school], [role], [program-school], [city]
 * Also handles capitalized versions: [Program], [School], etc.
 *
 * TODO: Once user profiles exist, accept program/school/city and use
 * the maps below to personalize (e.g. "Medicine" → "doctor").
 */

const roleMap = {
  Medicine: "doctor",
  Dentistry: "dentist",
  Pharmacy: "pharmacist",
  Nursing: "nurse",
  "Physical Therapy": "physical therapist",
  "Veterinary Medicine": "veterinarian",
  "Public Health": "public health professional",
}

const programSchoolMap = {
  Medicine: "medical school",
  Dentistry: "dental school",
  Pharmacy: "pharmacy school",
  Nursing: "nursing school",
  "Physical Therapy": "physical therapy school",
  "Veterinary Medicine": "veterinary school",
  "Public Health": "public health school",
}

const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1)

export function replaceQuestionVariables(text, { program, school, city } = {}) {
  if (!text) return text

  let result = text

  const programVal = program || "this profession"
  result = result.replace(/\[program\]/gi, (m) =>
    m === "[Program]" ? capitalize(programVal) : programVal
  )

  const schoolVal = school || "this school"
  result = result.replace(/\[school\]/gi, () => schoolVal)

  const cityVal = city || "this city"
  result = result.replace(/\[city\]/gi, () => cityVal)

  const role = program ? roleMap[program] || "healthcare professional" : "healthcare professional"
  result = result.replace(/\[role\]/gi, (m) =>
    m === "[Role]" ? capitalize(role) : role
  )

  const ps = program ? programSchoolMap[program] || "this school" : "this school"
  result = result.replace(/\[program-school\]/gi, (m) =>
    m === "[Program-school]" ? capitalize(ps) : ps
  )

  return result
}
